<div class="page-content">
    <div class="page-header">
        <h1>Mon espace</h1>
        <div class="page-description">Visualiser et accéder à vos études</div>
    </div>

    <div class="page-body">
        <app-studies
            [ccStudies]="concessionControls"
            [ccStudyHeaderTemplate]="ccStudyHeaderTemplate"
            [ccStudyBodyTemplate]="ccStudyBodyTemplate"
            [cracMaps]="cracMaps"
            [cracmapHeaderTemplate]="cracMapHeaderTemplate"
            [cracmapBodyTemplate]="cracMapBodyTemplate"></app-studies>
    </div>
</div>
<!-- CRAC Map -->

<ng-template #cracMapHeaderTemplate let-cracmap="cracmap">
    @if (cracmap.status === cracMapStatus.WAITING) {
        <ed-button
            (click)="contact(StudyType.CRACMAP, cracmap.year)"
            [colorSchema]="buttonColors.Secondary">
            Nous contacter
        </ed-button>
    } @else if (cracmap.status === cracMapStatus.PROCESSING) {
        <ed-button [disabled]="true">Ouvrir</ed-button>
    } @else if (cracmap.status === cracMapStatus.AVAILABLE) {
        <ed-button (click)="openCracMap(cracmap.year)">Ouvrir</ed-button>
    }
</ng-template>

<ng-template #cracMapBodyTemplate let-cracmap="cracmap">
    <div class="body">
        <div class="badge rounded-pill" [ngClass]="getBadgeClass(cracmap.status)">
            {{ getBadgeLabel(cracmap.status) }}
        </div>
    </div>
</ng-template>

<!--Concession Control-->
<ng-template #ccStudyHeaderTemplate let-study="study">
    @if (
        study.status === concessionControlStatus.WAITING ||
        study.status === concessionControlStatus.AWAITING_THE_ANNUAL_ORDER
    ) {
        <ed-button
            (click)="contact(StudyType.CC, study.year)"
            [colorSchema]="buttonColors.Secondary">
            Nous contacter
        </ed-button>
    } @else if (study.status === concessionControlStatus.PROCESSING) {
        <ed-button [disabled]="true">Ouvrir</ed-button>
    } @else if (study.status === concessionControlStatus.AVAILABLE) {
        <ed-button (click)="openConcessionControl(study.year)">Ouvrir</ed-button>
    }
</ng-template>

<ng-template #ccStudyBodyTemplate let-study="study">
    <div class="body">
        <div class="badge rounded-pill" [ngClass]="getBadgeClass(study.status)">
            {{ getBadgeLabel(study.status) }}
        </div>
        <p class="description" *ngIf="!!study.description">
            {{ study.description }}
        </p>
    </div>
</ng-template>
